/* eslint-disable @typescript-eslint/no-explicit-any */

export default function Button(props: {
  content: string
  className?: string
  link?: string
  type?: any
  disabled?: any
}) {
  const { link, className, content, type, disabled } = props

  return link ? (
    <a href={link} target='_blank'>
      <button
        className={`${className} bg-blue-600 py-2.5 px-6 rounded-md shadow-lg text-white font-black text-lg sm:text-xl hover:bg-blue-700 tracking-widest`}
        type={type}
      >
        {content}
      </button>
    </a>
  ) : (
    <button
      disabled={disabled}
      className={`${className} bg-blue-600 py-2.5 px-6 rounded-md shadow-lg text-white font-black text-lg sm:text-xl hover:bg-blue-700 tracking-widest disabled:cursor-not-allowed disabled:opacity-75 disabled:bg-gray-500`}
      type={type}
    >
      {content}
    </button>
  )
}
